import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { installGlobalErrorHandlers } from './telemetry/globalErrors.js';
import { installFpsMonitor } from './telemetry/fpsMonitor.js';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element #root not found in index.html');
}

// Установка global error handlers ДО render — ловит ошибки даже в первом
// React commit / initialization. ErrorBoundary потом ловит rendered errors,
// global ловит promise rejections и event-handler throws.
installGlobalErrorHandlers();

// 2026-05-26: FPS monitor — emit'ит perf.fps_sample каждые ~10s + одиночные
// perf.slow_frame на stutter'ы >200ms. JB видит реальные cifры в D1 без
// необходимости открывать Chrome DevTools на физическом устройстве.
installFpsMonitor();

// 2026-05-26 perf: при скрытии страницы (visibilitychange → hidden)
// ставим data-app-hidden="true" на <html>. CSS в globals.css по этому
// атрибуту приостанавливает все animation-play-state. Mobile compositor
// перестаёт жечь GPU/battery на 40+ infinite animations пока пользователь
// в другом чате TG / минимизировал браузер / lock'нул телефон.
function syncVisibilityAttr(): void {
  const hidden = document.visibilityState === 'hidden';
  document.documentElement.dataset.appHidden = hidden ? 'true' : 'false';
}
syncVisibilityAttr();
document.addEventListener('visibilitychange', syncVisibilityAttr);

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
